import { DefaultError, useMutation } from "@tanstack/react-query";
import { useQueryToast } from "hooks";
import i18next from "i18next";
import { apiClient } from "utils";
import { useResponseHandler } from "utils/service/responseHandler";
import { IChangePasswordForm } from "./types";

export const useChangePassword = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useChangePassword");
  return useMutation<any, DefaultError, IChangePasswordForm>({
    async mutationFn(body) {
      loading(
        i18next.t("service-message.change.loading", {
          what: i18next.t("user-settings.password-what"),
        })
      );

      const response = await apiClient({
        method: "POST",
        url: "Auth/ChangePassword",
        body,
      });

      return responseHandler(response, {
        groupName: "useChangePassword",
      });
    },
    onError: dismiss,
    onSuccess(data) {
      success(
        i18next.t("service-message.change.success", {
          what: i18next.t("user-settings.password-what"),
        })
      );
    },
  });
};
